export default "__VITE_ASSET__5b115c51__"